<template>
  <main v-loading.fullscreen.lock="loading">
    <!-- <div class="back-btn" @click="goHome()">
      <span>返回首页</span>
      <i class="el-icon-s-home" />
    </div> -->
    <div class="top-banner">
      <InstitutionCard :card-data="schoolInfo" />
    </div>
    <div class="list-container">
      <div class="title-box">
        <h2>直播列表</h2>
        <span>共{{ liveList.length }}场直播</span>
      </div>
      <div class="filter-box">
        <div class="filter-types">
          <div class="filter-type" :data-actived="filterType === 0" @click="filterType = 0">
            <el-image v-if="filterType === 0" :src="LiveTime" class="filter-icon" />
            <span>直播时间</span>
          </div>
          <div class="filter-type" :data-actived="filterType === 1" @click="filterType = 1">
            <el-image v-if="filterType === 1" :src="LiveMic" class="filter-icon" />
            <span>直播状态</span>
          </div>
        </div>
        <div v-if="filterType === 0" class="filter-content">
          <div
            v-for="item in yearList"
            :key="item"
            class="filter-item"
            :data-actived="searchForm.year === item"
            @click="searchForm.year = item"
          >{{ item }}</div>
        </div>
        <div v-if="filterType === 1" class="filter-content">
          <div
            v-for="item in statusList"
            :key="item.id"
            class="filter-item"
            :data-actived="searchForm.status === item.id"
            @click="searchForm.status = item.id"
          >{{ item.name }}</div>
        </div>
      </div>
      <div class="list-box">
        <ListCard v-for="item in liveList" :key="item.id" :card-data="item" />
      </div>
    </div>
  </main>
</template>

<script>
import wx from 'weixin-js-sdk';
import InstitutionCard from '../components/InstitutionCard';
import ListCard from '../components/ListCard';
import { getSchoolInfo, getLiveList, jsdkSignature } from '@/api/customer';
import LiveTime from '@/assets/images/icons/broadcast/live-time.svg';
import LiveMic from '@/assets/images/icons/broadcast/live-mic.svg';
export default {
  metaInfo() {
    return {
      title: this.schoolInfo.live_title || '招生直播宣讲会',
      meta: [
        {
          name: 'keywords',
          content: ''
        },
        {
          name: 'description',
          content: ''
        }
      ]
    }
  },
  components: {
    InstitutionCard,
    ListCard
  },
  data() {
    return {
      loading: false,
      LiveTime,
      LiveMic,
      filterType: 0,
      schoolId: 0,
      schoolInfo: {},
      yearList: [],
      statusList: [
        {
          id: 0,
          name: '全部',
        },
        {
          id: 2,
          name: '未开始',
        },
        {
          id: 3,
          name: '直播中',
        },
        {
          id: 1,
          name: '已结束',
        },
      ],
      searchForm: {
        year: '全部',
        type: 0,
        status: 0,
        keyword: ''
      },
      liveList: [],
    }
  },
  watch: {
    searchForm: {
      handler() {
        this.getLiveList();
      },
      deep: true
    }
  },
  async mounted() {
    this.loading = true;
    this.schoolId = this.$route.params.id;
    const { statusCode: schoolStatus, data: schoolData } = await getSchoolInfo({ id: this.schoolId });
    if (schoolStatus === 0) {
      this.schoolInfo = schoolData.school;
      this.yearList = ['全部', ...schoolData.years];
    }
    this.getLiveList();

    // 微信订阅-分享
    if (this.isWechat()) {
      const { data: wxData } = await jsdkSignature({ url: location.href });
      wx.config({
        debug: false,
        appId: wxData.appId,
        timestamp: wxData.timestamp,
        nonceStr: wxData.nonceStr,
        signature: wxData.signature,
        jsApiList: [ // 这里是需要用到的接口名称
          'checkJsApi', // 判断当前客户端版本是否支持指定JS接口
          'updateAppMessageShareData', // 分享
          'updateTimelineShareData', // 分享朋友圈
          'getLocation', // 获取位置
          'openLocation', // 打开位置
          'scanQRCode', // 扫一扫接口
          'chooseWXPay', // 微信支付
          'chooseImage', // 拍照或从手机相册中选图接口
          'previewImage', // 预览图片接口
          'uploadImage' // 上传图片
        ],
        openTagList: ["wx-open-subscribe"], // 必填，需要使用的JS接口列表
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: this.schoolInfo.live_title || '招生直播宣讲会',
          desc: this.schoolInfo.intro,
          link: location.href,
          imgUrl: this.schoolInfo.logo,
          success: function() {
            // 设置成功
            console.log('分享至聊天窗口成功');
          },
          fail: function() {
            console.log('分享至聊天窗口失败');
          }
        });
        // 分享到朋友圈及分享到QQ空间
        wx.updateTimelineShareData({
          title: this.schoolInfo.live_title || '招生直播宣讲会',
          desc: this.schoolInfo.intro,
          link: location.href,
          imgUrl: this.schoolInfo.logo,
          success: function() {
            // 设置成功
            console.log('分享朋友圈成功');
          },
          fail: function() {
            console.log('分享朋友圈失败');
          }
        });
      });
    }

    this.loading = false;
  },
  methods: {
    async getLiveList() {
      const { statusCode: listStatus, data: listData } = await getLiveList({
        schoolId: this.schoolId,
        ...this.searchForm,
        year: this.searchForm.year === '全部' ? '' : this.searchForm.year,
        status: this.searchForm.status === 0 ? '' : this.searchForm.status,
      });
      if (listStatus === 0) {
        this.liveList = listData;
      }
    },
    goHome() {
      this.$router.push({
        path: `/m/broadcast/index`,
      })
    },

    // 判断是否在微信
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // eslint-disable-line
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style lang="less" scoped>
main {
  background: linear-gradient(to bottom, #2C89F3, #0C49D6, #fff 22rem);

  .back-btn {
    position: fixed;
    width: 6.5rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    left: 0;
    bottom: 10rem;
    border-radius: 0 1.5rem 1.5rem 0;
    font-size: 0.875rem;
    background-color: #00000066;
    color: #FFFFFF;
    z-index: 999;

    i {
      font-size: 1.5rem;
    }
  }

  .top-banner {
    padding: 0.5rem 1rem;
  }

  .list-container {
    width: 100%;
    margin-top: 3rem;
    padding: 1rem;
    background-color: #FFFFFF;
    border-radius: 0.875rem 0.875rem 0 0;

    .title-box {
      position: absolute;
      padding: 0 1.5rem;
      width: calc(100% - 2rem);
      height: 3.25rem;
      left: 1rem;
      top: -1.5rem;
      background: url("~@/assets/images/backgrounds/broadcast/title-banner.webp");
      background-size: cover;
      color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        font-size: 1rem;
      }
      span {
        font-size: 0.875rem;
      }
    }

    .filter-box {
      margin-top: 2rem;
      padding: 0 1.5rem;

      .filter-types {
        display: flex;
        align-items: center;
        gap: 1.25rem;

        .filter-type {
          display: flex;
          align-items: center;
          gap: 0.325rem;

          .filter-icon {
            width: 1.25rem;
            height: 1.25rem;
          }
          span {
            font-size: 0.875rem;
          }

          &[data-actived="true"] {
            span {
              font-size: 1rem;
              font-weight: bold;
            }
          }
        }
      }

      .filter-content {
        display: flex;
        gap: 0.625rem;
        margin-top: 1.25rem;

        .filter-item {
          width: fit-content;
          height: 1.5rem;
          padding: 0 0.625rem;
          border-radius: 0.75rem;
          background-color: #EDF4FF;
          color: #2173EA;
          font-size: 0.75rem;
          display: flex;
          align-items: center;

          &[data-actived="true"] {
            background-color: #2173EA;
            color: #FFFFFF;
          }
        }
      }
    }

    .list-box {
      margin-top: 1.5rem;
    }
  }
}
</style>
